export default __webpack_public_path__ + "static/media/free-delivery.3e3b8ff7.svg";